import "./blog.scss";
import { blogs } from "../../services/data";
import { BackButton } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
export default function BlogPage() {
    var blogIndex = localStorage.getItem('blogIndex');
    var blog=blogs.find((e)=>e.id===(blogIndex || '0'));
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    
    return (<div className="blogPage">
        <BackButton name="Back"/>
        <div className="image">
            <img src={blog?.image} alt="image" />
            <div className="guard">{blog?.heading}</div>
        </div>
        <div className="content">
            {blog?.pars.map((item, i) => {
                return <>
                    <div key={i} className={`para ${lightMode ? "lightShadow" : "darkShadow"}`}>
                        <div className="head">{item.heading}</div>
                        <div className="body" dangerouslySetInnerHTML={{ __html: item.content }}></div>
                    </div>
                    {i === 2 ? <div className="image">
                        <img src={blog?.image} alt="image" />
                    </div> : <span />}
                </>
            })}
        </div>
    </div>)
}

